export const customFetcher = <TData, TVariables>(
  query: string,
  variables?: TVariables,
  options?: RequestInit['headers']
) => {
  return async (): Promise<TData> => {
    const NEXT_PUBLIC_API_URL = process.env['NEXT_PUBLIC_API_URL'] as string
    const res = await fetch(NEXT_PUBLIC_API_URL || 'https://platform-api.olby.com/graphql', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Accept: 'application/json',
        ...options,
      },
      body: JSON.stringify({ query, variables }),
    })

    const json = await res.json()

    if (json.errors) {
      const errors = json.errors[0]

      throw errors
    }

    return json.data
  }
}
